import React, { Fragment } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "../Layout";
import DashboardWidgetsPP from "./DashboardWidgetsPP";
import MessageBoardPP from "./MessageBoardPP";
import InsuranceAdsPP from "./InsuranceAdsPP";
import ActionsPP from "./ActionsPP";
import TrackSsoUrlComponent from "../../common/TrackSsoUrlComponent";

const leftColumnWidgets = () => {
  return (
    <Fragment>
      <ActionsPP />
    </Fragment>
  );
};

const rightColumnWidgets = ({ ...rest }) => {
  return (
    <Fragment>
      <MessageBoardPP {...rest} />
      <InsuranceAdsPP {...rest} />
      <DashboardWidgetsPP {...rest} />
    </Fragment>
  );
};

const DashboardPP = ({ selectedLanguage, commonConfig, getShortLivedToken }) => {
  return (
    <Fragment>
      <TrackSsoUrlComponent getShortLivedToken={getShortLivedToken} />
      <DashboardLayout
        leftColumn={leftColumnWidgets()}
        rightColumn={rightColumnWidgets({
          commonConfig,
          selectedLanguage,
          getShortLivedToken,
        })}
      />
    </Fragment>
  );
};

DashboardPP.propTypes = {
  selectedLanguage: PropTypes.object,
  commonConfig: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object.isRequired),
    PropTypes.object,
  ]),
  getShortLivedToken: PropTypes.func.isRequired,
};

export default DashboardPP;



// WEBPACK FOOTER //
// ./components/dashboard/DashboardNewUI/DashboardPP.js